import {
  setupClass, 
} from '../Base.js'
import { valOr, formatNumBrief, } from '../SharedUtils.js'
import { CsvHelper } from '../MaterialData/CsvHelper.js'

import { Units, } from '../Common/Units.js'

/**
 * Represents a simple data table (either entered manually or loaded from CSV).
 * Note - the conversion from std to project units occurs in the DataTable Vue component,
 */
export class DataTable {
  init(cols, rowData) {
    this.cols = cols
    this.rowData = rowData
  }

  static createFromCSV(csvStr, columnsDesc) {
    columnsDesc = valOr(columnsDesc, {})

    //console.log(`CREATING DataTable from CSV`, columnsDesc)
    let csvHelper = new CsvHelper(csvStr)
    let cols = []
    for (let i = 0; i < csvHelper.numCols(); ++i) {
      let colName = csvHelper.csv.data[0][i]
      let colUnits = columnsDesc[colName]?.units || Units.None;
      cols.push({
        name: colName,
        field: `row${i}`,
        units: colUnits,
        precision: columnsDesc[colName]?.precision,
      })
    }
    let rowData = {}
    for (let i = 1; i < csvHelper.numRows(); ++i) {
      let row = {}
      //console.log(`Row ${i}: ${csvHelper.csv.data[i]}`)
      for (let j = 0; j < csvHelper.numCols(); ++j) {
        row[`row${j}`] = csvHelper.csv.data[i][j];
      }
      //console.log(`Row ${i}: ${JSON.stringify(row)}`)
      rowData[i] = row
    }
    return DataTable.create(cols, rowData);
  }
}
setupClass(DataTable)